import React from 'react';
import styled from 'styled-components';
import useContentAsociacionUsuariosMiembros from '../hooks/parameter/useContentAsociacionUsuariosMiembros.js';
import useContentModeradora from '../hooks/parameter/useContentModeradora.js';

const DivContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;

  p {
    text-align: center;

    img {
      margin-top: 2.5rem;
      width: 100% !important;
    }
  }
`;

export const PageMiembros = () => {
  window.scroll(0, 0);
  const { asociacionUsuariosMiembros } = useContentAsociacionUsuariosMiembros();
  const bodyHTML =
    asociacionUsuariosMiembros.length > 0 &&
    asociacionUsuariosMiembros[0].texto_completo;

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <DivContainer id='contBodyHTML'>
          <p dangerouslySetInnerHTML={{ __html: bodyHTML }} />
        </DivContainer>
      </div>
    </>
  );
};
